import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { AuthenticationService } from '@modules/authentication/services/authentication.service';
import { formatUsername } from '@pixacare/shared';
import { TuiDialogContext } from '@taiga-ui/core';
import { POLYMORPHEUS_CONTEXT } from '@taiga-ui/polymorpheus';
import {
  UserIdentityModuleComponentInputs,
  UserIdentityModuleComponentOutputs,
} from '../models/user-identity-module-component';

@Component({
  selector: 'pxc-user-identity',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col gap-4' },
})
export class UserIdentityComponent implements OnInit {
  private readonly authenticationService = inject(AuthenticationService);
  private readonly context =
    inject<TuiDialogContext<UserIdentityModuleComponentOutputs | null, UserIdentityModuleComponentInputs>>(
      POLYMORPHEUS_CONTEXT,
    );

  ngOnInit(): void {
    const currentUser = this.authenticationService.user;

    if (!currentUser) {
      this.context.completeWith(null);
      return;
    }

    this.context.completeWith({
      id: currentUser.id.toString(),
      firstName: currentUser.firstName,
      lastName: currentUser.lastName,
      fullName: formatUsername(currentUser, { format: 'default' }),
      mailAddress: currentUser.mailAddress,
    });
  }
}
